import { render, staticRenderFns } from "./terminatedForm.vue?vue&type=template&id=89fbc208&"
import script from "./terminatedForm.vue?vue&type=script&lang=js&"
export * from "./terminatedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports